import { FOR_ONE_DAY, FOR_ONE_WEEK, timestampToTime } from './timestampToTime'

export const getLessonPeriod = ({
  boundaryTime = 20,
  date,
  isLocation,
  isMulticreator,
}: {
  boundaryTime: number
  date?: number
  isLocation?: boolean
  isMulticreator?: boolean
}) => {
  const now = date ? new Date(date) : new Date()
  let baseTime = now.getTime()

  // 年末の特定日設定
  const decemberPeriod = findSpecialPeriod(
    now,
    isLocation ? decemberSpecialPeriodForLocation : decemberSpecialPeriod,
    boundaryTime
  )
  if (!isMulticreator && decemberPeriod) {
    return decemberPeriod
  }

  // 年始の特定日設定
  const januaryPeriod = findSpecialPeriod(
    now,
    isLocation ? januarySpecialPeriodForLocation : januarySpecialPeriod,
    boundaryTime
  )
  if (!isMulticreator && januaryPeriod) {
    return januaryPeriod
  }

  // 通常の処理: boundaryTime以降は翌日開始、それ以外は当日開始
  if (now.getHours() >= boundaryTime) {
    baseTime += FOR_ONE_DAY
  }

  return {
    start_date: timestampToTime(baseTime),
    end_date: timestampToTime(baseTime + FOR_ONE_WEEK),
  }
}

// https://linear.app/she-inc/issue/GWH-1614/%E5%B9%B4%E6%9C%AB%E5%B9%B4%E5%A7%8B%E3%81%AE%E6%9E%A0%E6%98%8E%E3%81%91-trial-lesson
// 2025-2026年末年始の表記変更
const decemberSpecialPeriod = [
  { month: 11, date: 31, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 11, date: 30, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 11, date: 29, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 11, date: 28, start_date: '2025-12-28', end_date: '2026-01-08' },
  { month: 11, date: 27, start_date: '2025-12-27', end_date: '2026-01-08' },
]

const januarySpecialPeriod = [
  { month: 0, date: 4, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 0, date: 3, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 0, date: 2, start_date: '2026-01-04', end_date: '2026-01-08' },
  { month: 0, date: 1, start_date: '2026-01-04', end_date: '2026-01-08' },
]

const decemberSpecialPeriodForLocation = [
  { month: 11, date: 31, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 11, date: 30, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 11, date: 29, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 11, date: 28, start_date: '2025-12-28', end_date: '2026-01-11' },
  { month: 11, date: 27, start_date: '2025-12-27', end_date: '2026-01-10' },
]

const januarySpecialPeriodForLocation = [
  { month: 0, date: 4, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 0, date: 3, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 0, date: 2, start_date: '2026-01-04', end_date: '2026-01-11' },
  { month: 0, date: 1, start_date: '2026-01-04', end_date: '2026-01-11' },
]

function findSpecialPeriod(
  now: Date,
  periods: {
    month: number
    date: number
    start_date: string
    end_date: string
  }[],
  boundaryTime: number
) {
  for (const { month, date, start_date, end_date } of periods) {
    if (
      now.getMonth() === month &&
      (now.getDate() === date ||
        (now.getDate() === date - 1 && now.getHours() >= boundaryTime))
    ) {
      return { start_date, end_date }
    }
  }
  return null
}
